export default {"src":"/hedera/_next/static/media/staderLogo.c92c931b.svg","height":33,"width":20};